import socket from './config'
// import store from '../../store/index'
import cookie from 'vue-cookie'


// // this event fires when connection is established between the client & server
socket.on('connect', () => {
  // socket.emit('newConnection', store.state.userDetails)
  console.log('socketId: ', socket.id)
  let userDetails = cookie.get(process.env.VUE_APP_PORTAL_YG_USER)
  userDetails = (userDetails && userDetails !== 'undefined') ? JSON.parse(userDetails) : null
  if (userDetails && userDetails._id) socket.emit('updateSocketId', userDetails)
})

socket.on('broadcast', (msg) => {
  console.log(msg, 'moduleUpdate')
})

socket.on('activeUsers', (users) => {
  // store.commit('setActiveUsers', users)
  console.log('active-users', users)
  // console.log(store.getters.activeUsers, 'activeUsers')
})

// socket.on('disconnect', () => {
//   let { token } = store.state
//   if (token) {
//     // store.dispatch('logout')
//     // this.$root.$emit('snackbar', { message: 'Logged Out Successfully', color: 'success' })
//   }
// })

export default {
  install (Vue) {
    Vue.prototype.$socket = socket
  }
}


// error-handling
socket.on('connect_failed', () => {
  console.error('Sorry, there seems to be an connection failed with the connection!')
  // store.dispatch('logout')
})

socket.on('connect_error', () => {
  console.error('Sorry, there seems to be error with the connection!')
  // store.dispatch('logout')
})

socket.on('Connect_timeout', () => {
  console.error('Sorry, it seems to be timeout of socket connection!')
  // store.dispatch('logout')
})

socket.on('error', () => {
  console.error('Sorry, it seems to be an error with the connection!')
  // store.dispatch('logout')
})

socket.on('reconnect_failed', () => {
  console.error('Sorry, Reconnection with the connection is failed!')
  // store.dispatch('logout')
})
